import Grid from "@mui/material/Grid";
import FormField from "../../../../../components/FormField";
import MDBox from "../../../../../components/MDBox";
import React from "react";

function EditPayoutForm({ formData }) {
    const { formField, values, errors, touched } = formData;

    const {paid_at, voucher} = formField;
    const {
        paid_at: paidAtV,
        voucher: voucherV,
    } = values;

    return (
        <MDBox>
            <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={paid_at.type}
                        label={paid_at.label}
                        name={paid_at.name}
                        value={paidAtV}
                        options={paid_at.options}
                        error={errors.paid_at && touched.paid_at}
                        success={paidAtV && paidAtV.length > 0 && !errors.paid_at}
                    />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <FormField
                        type={voucher.type}
                        label={voucher.label}
                        name={voucher.name}
                        value={voucherV}
                        error={errors.voucher && touched.voucher}
                        success={voucherV && voucherV.length > 0 && !errors.voucher}
                        {...voucher}
                    />
                </Grid>
            </Grid>
        </MDBox>
    );
}

export default EditPayoutForm;
